import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { home, system_manager } from '../assets/conf_urls.json';
import { throwError } from 'rxjs';
@Injectable()

export class ReportGeneratorService {

  constructor(private http: HttpClient) {

  }

  systemsReceiver(headersToBeSent: string, ids: string): Observable<any> {
    if (headersToBeSent == "") {
      return throwError('No data were selected');
    }
    return this.http.post<any>(system_manager.services, {
      "event": "reportGenerator",
      "headersToBeSent": headersToBeSent,
      "sys": ids
    })
  }

}
